/*
 * GENERAL DECIMAL HELPERS
 * */

import Decimal from "decimal.js";

export const getDecimalValue = (value: string | number): Decimal => {
    // fix no_iva and no_ret
    if (typeof value === 'string' && value.toUpperCase().includes('SIN')) {
        value = 0;
    }

    return new Decimal(`${value}`);
};

export const mulDecimal = (a: Decimal, b: Decimal): number => {
    return a.mul(b).toNumber();
};

export const plusDecimal = (a: Decimal, b: Decimal): number => {
    return a.plus(b).toNumber();
};

export const minusDecimal = (a: Decimal, b: Decimal): number => {
    return a.minus(b).toNumber();
};

export const divideDecimal = (a: Decimal, b: Decimal): number => {
    return a.dividedBy(b).toNumber();
};